<template>
  <button
    @click="$emit('button-click')"
    type="button"
    :class="['button', { 'button--outlined': outlined }]"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  emits: ["button-click"],

  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  border-radius: 30px;
  padding: 10px 30px;
  color: white;
  font-weight: 600;
  max-width: 60%;
  background: linear-gradient(var(--main-gradient));
  border-bottom: 5px solid var(--main-color);

  &--outlined {
    background: transparent !important;
    border: 2px solid var(--main-color);
    border-bottom: 2px solid var(--main-color);
    color: var(--main-color) !important;
  }
}
</style>
